import React, { Component } from "react";
import AssessmentCommon from './AssessmentCommon'

export class AssessmentInterviewer extends Component {
  render() {
    return (
      <AssessmentCommon personType={1} />
    );
  }
}
